import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=36fa169e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fa169e')) {
      api.createRecord('36fa169e', component.options)
    } else {
      api.reload('36fa169e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=36fa169e&", function () {
      api.rerender('36fa169e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25dR36CZQ4gZE/JS/comp/openstreetmap.vue"
export default component.exports